import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type LinkBubbleUrlMetadataQueryVariables = Types.Exact<{
  input: Types.UrlMetadataInput;
}>;

export type LinkBubbleUrlMetadataQuery = {
  __typename?: 'Query';
  urlMetadata: {
    __typename?: 'UrlMetadataResponse';
    finalUrl: string;
    error?: { __typename?: 'UrlMetadataError'; code: number; message: string; type: string } | null;
    metadata?: { __typename?: 'UrlMetadata'; title?: string | null; description?: string | null; imageUrl?: string | null } | null;
  };
};

export const LinkBubbleUrlMetadataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LinkBubbleUrlMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UrlMetadataInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'urlMetadata' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'finalUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLinkBubbleUrlMetadataQuery__
 *
 * To run a query within a React component, call `useLinkBubbleUrlMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkBubbleUrlMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkBubbleUrlMetadataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkBubbleUrlMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LinkBubbleUrlMetadataQuery, LinkBubbleUrlMetadataQueryVariables>) {
  return ApolloReactHooks.useQuery<LinkBubbleUrlMetadataQuery, LinkBubbleUrlMetadataQueryVariables>(LinkBubbleUrlMetadataDocument, baseOptions);
}
export function useLinkBubbleUrlMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkBubbleUrlMetadataQuery, LinkBubbleUrlMetadataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<LinkBubbleUrlMetadataQuery, LinkBubbleUrlMetadataQueryVariables>(LinkBubbleUrlMetadataDocument, baseOptions);
}
export type LinkBubbleUrlMetadataQueryHookResult = ReturnType<typeof useLinkBubbleUrlMetadataQuery>;
export type LinkBubbleUrlMetadataLazyQueryHookResult = ReturnType<typeof useLinkBubbleUrlMetadataLazyQuery>;
export type LinkBubbleUrlMetadataQueryResult = Apollo.QueryResult<LinkBubbleUrlMetadataQuery, LinkBubbleUrlMetadataQueryVariables>;
